import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmTool } from "@/mixins/index";
import activities from "./mixins/activities";
import { serverList, addActivityList, updActivityList, activityTypeList } from "@/api/gmtool/packageCode";
export default {
  name: "configurationActivities",
  mixins: [gmTool, activities],
  data: function data() {
    return {
      paramsData: {
        is_prod: "",
        days: "",
        config_type_id: "",
        server_list: [],
        id: ""
      },
      TypeList: [],
      paramsDataMark: {},
      serverListsOr: [],
      serverLists: [],
      dayInput: null,
      rules: {
        server_list: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        config_type_id: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }]
      },
      reqLoading: false
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.paramsDataMark = JSON.parse(JSON.stringify(_this.paramsData));
              _this.dayInput = _this.$utils.debounce(_this.dayChange, 500);

              _this.getserverList();

              _this.domShow();

              _this.$bus.$on("editingAc", /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
                  var data, list, i;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this.$refs.ruleForm.clearValidate();

                          data = JSON.parse(JSON.stringify(row));
                          data.is_prod = data.env;
                          list = data.server_list.split(",");
                          data.server_list = list.map(function (i) {
                            return parseInt(i);
                          });

                          for (i in _this.paramsData) {
                            _this.paramsData[i] = data[i];
                          }

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  methods: {
    // 组件展示时触发
    domShow: function domShow() {
      this.getAcType();
      this.getserverList();
    },
    // 获取活动类型
    getAcType: function getAcType() {
      var _this2 = this;

      activityTypeList().then(function (res) {
        if (res.status == 200) {
          _this2.TypeList = res.data;

          if (_this2.paramsData.config_type_id && res.data.findIndex(function (i) {
            return i.id == _this2.paramsData.config_type_id;
          }) == -1) {
            _this2.paramsData.config_type_id = "";
          }
        }
      });
    },
    getserverList: function getserverList() {
      var _this3 = this;

      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return new Promise(function (resolve, reject) {
        if (isClear) {
          _this3.paramsData.server_list = [];
        }

        serverList({
          is_prod: _this3.paramsData.is_prod
        }).then(function (res) {
          if (res.status == 200) {
            _this3.serverListsOr = res.server_merge_list;
            _this3.serverLists = res.server_merge_list;

            _this3.allSeverList();
          }
        }).finally(function () {
          resolve();
        });
      });
    },
    // 全选服务器
    allSeverList: function allSeverList() {
      this.paramsData.server_list = this.serverLists.map(function (i) {
        return i.serverID;
      });
    },
    dayChange: function dayChange() {
      var _this4 = this;

      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (isClear) {
        this.paramsData.server_list = [];
      }

      var list = [];
      this.serverListsOr.forEach(function (i) {
        var time = _this4.$times.formDate(i.openTime);

        if (_this4.$times.differenceTime(time) >= Number(_this4.paramsData.days)) {
          list.push(i);
        }
      });
      this.serverLists = list;
      this.allSeverList();
    },
    claerData: function claerData() {
      this.$refs.ruleForm.clearValidate();
      this.paramsData = _objectSpread(_objectSpread({}, this.paramsDataMark), {}, {
        is_prod: this.paramsData.is_prod
      });
      this.dayChange();
      this.allSeverList();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this5 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this5.reqLoading = true;
          var data = JSON.parse(JSON.stringify(_this5.paramsData));
          data.page_size = "";
          data.server_list = data.server_list.toString();
          var reqFn = data.id ? updActivityList : addActivityList;
          reqFn(data).then(function (res) {
            if (res.status == 200) {
              _this5.$message({
                message: _this5.$t('operationSuccess'),
                type: "success"
              });

              _this5.claerData();

              if (data.id) {
                _this5.$bus.$emit("AcList");
              }
            }
          }).finally(function () {
            _this5.reqLoading = false;
          });
        }
      });
    }
  }
};